module.exports = __webpack_public_path__ + "img/eherkenning.0e0bb794.png";